import styled from 'styled-components';
import * as React from 'react';
import CalendarNavButton from '../../../components/Calendar/CalendarNavButton';

interface Props {
  text: string;
  onNextClick?: (event: React.MouseEvent) => void;
  onPrevClick?: (event: React.MouseEvent) => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Label = styled.span`
  color: ${p => p.theme.color.black2};
  font-weight: ${p => p.theme.font.weight.medium};
  font-size: 16px;
  margin: 0 20px;
`;

export const TimePeriodPicker = (props: Props) => {
  return (
    <Container>
      <CalendarNavButton iconName="arrow-left-circle-outlined" onClick={props.onPrevClick} />
      <Label>{props.text}</Label>
      <CalendarNavButton iconName="arrow-right-circle-outlined" onClick={props.onNextClick} />
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Stats/Components/TimePeriodPicker.tsx